export Checkboxes_Input from './Checkboxes_Input';
export Routing_Checkboxes_Input from './Routing_Checkboxes_Input';
export Field_Component_Input from './Field_Component_Input';
export Gplus_Input from './Gplus_Input';
export Like_Input from './Like_Input';
export Matrix_Input from './Matrix_Input';
export Select_Component_Input from './Select_Component_Input';
//export * from '../base';
require('../base');


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/index.js
 **/